import {Link} from "react-router-dom";

export const DeclareSettlement = ({settlement_ekatte, settlement, region, municipality}) => {
    return (
        <tr>
            <th scope="row">{settlement_ekatte}</th>
            <td><Link style={{color: "var(--app-gold)", textDecoration: "none"}} to={`${settlement_ekatte}/companies`}>{settlement}</Link>
            </td>
            <td>{municipality}</td>
            <td>{region}</td>
        </tr>
    )
}